import { apiRequest } from './httpRequest';
import type { IllustrationDrawingDocument } from '@peruselab/structure-editor/domain/illustrationElement';

export interface IllustrationResponse {
  readonly id: string;
  readonly documentRevision: number;
  readonly title: string | null;
  readonly schemaVersion: string;
  readonly document: IllustrationDrawingDocument;
  readonly ownerType: string;
  readonly ownerId: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export async function createIllustration(
  document: IllustrationDrawingDocument,
  title?: string
): Promise<IllustrationResponse> {
  const normalizedTitle = title?.trim();
  const query = normalizedTitle ? `?${new URLSearchParams({ title: normalizedTitle })}` : '';
  return apiRequest<IllustrationResponse>(`/illustrations${query}`, 'illustration', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(document)
  });
}

// #140: fetching an already-saved Illustration, used to round-trip-verify a save.
export async function getIllustration(id: string): Promise<IllustrationResponse> {
  return apiRequest<IllustrationResponse>(`/illustrations/${encodeURIComponent(id)}`, 'illustration');
}
